import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbItem from './BreadcrumbItem';

const Breadcrumbs = (props) => {
  const { breadcrumbs } = props;

  return (
    <div>
      <div className="breadcrumbs">
        <ul className="no-list">
          {breadcrumbs.map((elem, index) => {
            if (index === breadcrumbs.length - 1) {
              return <BreadcrumbItem key={elem.name} title={elem.name} url={elem.uri} active />;
            }

            return <BreadcrumbItem key={elem.name} title={elem.name} url={elem.uri} />;
          })}
        </ul>
      </div>
    </div>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape),
};

Breadcrumbs.defaultProps = {
  breadcrumbs: [],
};


export default Breadcrumbs;
